import './index.scss'
$("header .nav a").eq(4).addClass("active")